module.exports = __webpack_public_path__ + "static/media/Image8.146b4347.png";